import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { AuthFactoryService } from 'src/app/auth/authFactory.service';
import { SettingsService } from '../../services/settings.service';

@Component({
  selector: 'app-settings',
  template: '',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
  constructor(private authFactoryService: AuthFactoryService, private service: SettingsService) {}

  ngOnInit() {
    const user = this.authFactoryService.getUser();
    this.service
      .getClientSettings()
      .pipe(take(1))
      .subscribe((settings) => {
        this.service.dispatchGetClientSettings(user?.agencyId);
        this.service.dispatchGetCurrencies();
      });
  }
}
